// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-page-front-js": () => import("./../../../src/templates/page--front.js" /* webpackChunkName: "component---src-templates-page-front-js" */),
  "component---src-templates-page-node-job-js": () => import("./../../../src/templates/page--node-job.js" /* webpackChunkName: "component---src-templates-page-node-job-js" */)
}

